import { handleRequest } from "../utilities/requestHandler";

export const getRecommendationsProductList = (req_body) =>
    handleRequest("post", "/recommendations/products/list", req_body);

export const deleteRecommendationProduct = (req_body) =>
    handleRequest("post", "/recommendations/products/delete", req_body);

export const getRecommendationsByUserAndSite = (userId, siteId,cus_id) =>
    handleRequest("get", `/recommendations/${userId}/${siteId}/${cus_id}`);

export const deleteRecommendation = (id, req_body) =>
    handleRequest("delete", `/recommendations/${id}`, req_body);

export const createRecommendation = (req_body) =>
    handleRequest("post", "/recommendations", req_body);